import { jsx as _jsx } from "react/jsx-runtime";
/**
 * hallmark critique · App
 * tokens locked from docs/design.md
 * states covered: connecting · connected · polling · disconnected (via useLiveFeed)
 *                 loading (traces) · ready · error (transient fetch fail)
 *                 nav: overview · demand · sim · docs (Phase 6)
 * mobile verified: 320 / 375 / 414 / 768
 * no fake chrome · no italic headers · no shadows · single clay accent per viewport
 *
 * Phase 4 boot: `useLiveFeed` opens the WebSocket (with polling fallback +
 * exponential reconnect) and `useSimTraces` fetches the two latest sim
 * traces. Phase 6 adds a nav state lifted to App: Overview / Demand / Sim
 * / Docs. When the Demand tab is active, AppShell branches to render the
 * PrivacyPanel + DemandHeatmap layer; on every other tab the shell keeps
 * the Phase 4 alert-rail wiring.
 */
import { useMemo, useState } from "react";
import { AppShell } from "./components/layout/AppShell";
import { useLiveFeed } from "./hooks/useLiveFeed";
import { useSimTraces } from "./hooks/useSimTraces";
import { usePhantomFeed } from "./hooks/usePhantomFeed";
import { toBunchAlertUi } from "./types/alert";
export function App() {
    const [activeNav, setActiveNav] = useState("overview");
    const live = useLiveFeed();
    const traces = useSimTraces();
    const phantom = usePhantomFeed();
    const alerts = useMemo(() => {
        if (!live.envelope)
            return [];
        return live.envelope.alerts.map(toBunchAlertUi);
    }, [live.envelope]);
    return (_jsx(AppShell, { liveEnvelope: live.envelope, connectionState: live.connectionState, connectionError: live.lastError, reconnectAttempts: live.reconnectAttempts, alerts: alerts, daganzoTrace: traces.daganzo, mpcTrace: traces.mpc, tracesLoading: traces.loading, tracesError: traces.error, activeNav: activeNav, onNavChange: setActiveNav, phantom: phantom }));
}
